<template>
  <a-row :style="mainStyle" class="infoNote">
    <a-col :span="8" style="height: 100%;">
      <a-icon :type="icon" :style="iconStyle"/>
    </a-col>
    <a-col :span="16">
      <a-row style="height: 40px; margin-top: 3px; text-align: center; overflow: hidden;">
        <a-tooltip :title="detalle">
          <h1 style="font-size: 15px; font-weight: bold;" :style="{color: this.iconColor}">{{title}}</h1>
        </a-tooltip>
      </a-row>
      <a-row style="text-align: center;">{{subtitle}}</a-row>
    </a-col>
  </a-row>
</template>
<script>
  export default {
    props: ['icon', 'iconColor', 'title', 'subtitle', 'bgColor', 'borderColor', 'detalle'],
    data () {
      return {
        mainStyle: {
          height: '80px',
          padding: '5px',
          'border-color': this.borderColor,
          'background-color': this.bgColor
        },
        iconStyle: {fontSize: '70px', color: this.iconColor}
      }
    }
  }
</script>
<style>
  .infoNote {
    background-color: #f6ffed;
    border: 1px solid #b7eb8f;
    border-radius: 4px;
  }
</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/components/Dashboard/InfoNote.vue